/**
 * Standard centered loading / error / empty panel.
 *
 * Pulled out of eight routes that each defined a local `Centered`
 * helper with the same `mx-auto max-w-2xl px-6 py-24 text-center
 * text-ink-700` <section>.
 *
 * Two width variants:
 *   - "narrow" (default): max-w-2xl, py-24 — the loading/error panel.
 *   - "wide": max-w-3xl, py-20 — the "no X seeded yet" empty panel
 *     used by /lexicon and /constructions.
 */

import type { ReactNode } from "react";

type CenteredProps = {
  children: ReactNode;
  width?: "narrow" | "wide";
};

export function Centered({ children, width = "narrow" }: CenteredProps) {
  const className =
    width === "wide"
      ? "mx-auto max-w-3xl px-6 py-20 text-center text-ink-700"
      : "mx-auto max-w-2xl px-6 py-24 text-center text-ink-700";
  return <section className={className}>{children}</section>;
}
